<template>
    <v-navigation-drawer v-model="drawer" app width="280px">
        <v-list dense>
            <v-list-item to="/" :color="primaryColor" link>
                <v-list-item-action>
                    <v-icon color="#3699FF">mdi-home</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Home</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="resolvePermission('adminapplicants')" to="/applicants" :color="primaryColor" link>
                <v-list-item-action>
                    <v-icon color="#FFA800">mdi-file-multiple</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Applicants</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="resolvePermission('adminresidents')" :href="resxlink" target="_blank" :color="primaryColor" link>
                <v-list-item-action>
                    <v-icon color="#FFA800">mdi-home-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Residents</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-group v-if="resolvePermission('adminapplicants')" :color="primaryColor">
                <template v-slot:activator>
                    <v-list-item-icon>
                        <v-icon color="#1BC5BD">mdi-folder</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Forms</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in applicantForms" :key="i" :to="item.path">
                    <v-list-item-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.label }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
            <v-list-item v-for="(item, i) in getPermissions" :key="i" :to="item.path" :color="primaryColor" link>
                <v-list-item-action>
                    <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ item.label }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-group v-if="resolvePermission('adminsystemconfiguration')" :color="primaryColor">
                <template v-slot:activator>
                    <v-list-item-icon>
                        <v-icon color="#1BC5BD">mdi-cog</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>System Configuration</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in systemConfig" :key="i" :to="item.path">
                    <v-list-item-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.label }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import auth from '../../js/auth';

export default {
    name: 'admin-navigation',
    props: {
        drawer: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            resxlink: `https://${location.hostname}/res-x/`,
            applicantForms: [{
                label: 'Release of Information',
                path: '/forms/release-of-information'
            }],
            navItems: [{
                    color: '#F64E60',
                    icon: 'mdi-account-cog',
                    id: 'adminpermissions',
                    label: 'Permissions',
                    path: '/permissions'
                },
                {
                    color: '#8950FC',
                    icon: 'mdi-file-export',
                    id: 'adminreports',
                    label: 'Reports',
                    path: '/reports'
                },
                {
                    color: '#3699FF',
                    icon: 'mdi-account-group',
                    id: 'adminresidenceassistantmanager',
                    label: 'Residence Assistant Manager',
                    path: '/residence-assistant-manager'
                },
                {
                    color: '#FFA800',
                    icon: 'mdi-chart-line',
                    id: 'adminstatistics',
                    label: 'Statistics',
                    path: '/statistics'
                },
                {
                    color: '#0A7029',
                    icon: 'mdi-handshake',
                    id: 'adminroommatematcher',
                    label: 'Pairing & Placement',
                    path: '/pairingnplacement'
                },
            ],
            systemConfig: [{
                    label: 'Announcements',
                    path: '/system-configuration/announcements'
                }, {
                    label: 'Buildings',
                    path: '/system-configuration/buildings'
                },
                {
                    label: 'Meal Plans',
                    path: '/system-configuration/meal-plans'
                },
                {
                    label: 'Registered At',
                    path: '/system-configuration/registered-at'
                },
                {
                    label: 'Residence Terms',
                    path: '/system-configuration/residence-terms'
                },
                {
                    label: 'Year of Study',
                    path: '/system-configuration/year-of-study'
                }
            ]
        }
    },
    methods: {
        resolvePermission(permission) {
            let user = auth.getUser();

            // Resolve admin permissions
            if (user.rootGroupUser == "1") {
                return true;
            }

            // Resolve user permissions
            if (user.permissions[permission] && user.permissions[permission].enabled == 1) {
                return true;
            }

            return false;
        }
    },
    computed: {
        getPermissions() {
            let user = auth.getUser();
            let items = [];

            // Resolve admin permissions
            if (user.rootGroupUser == "1") {
                return this.navItems;
            }

            // Resolve user permissions
            for (let i = 0; i < this.navItems.length; i++) {
                let key = this.navItems[i].id;
                if (user.permissions[key] && user.permissions[key].enabled == 1) {
                    items.push(this.navItems[i]);
                }
            }

            return items;
        },
        primaryColor() {
            return '#5867dd';
        }
    }
}
</script>